module.exports = __webpack_public_path__ + "static/banner-4-32d73cd1dffb2425477d9af465543a68.jpg";